import { WAIT_FOR_ACTION, ERROR_ACTION } from 'redux-wait-for-action';

export const GET_IMAGE = 'downloadImagereducer/GET_IMAGE';
export const GET_IMAGE_SUCCESS = 'downloadImagereducer/GET_IMAGE_SUCCESS';
export const GET_IMAGE_FAILURE = 'downloadImagereducer/GET_IMAGE_FAILURE';

const defaultState = {
  loading: false,
  image: null,
  error: null
}

function downloadImageReducer(state = defaultState, action) {
  switch (action.type) {
    case GET_IMAGE:
      return { ...state, loading: true, image: null, error: null };
    case GET_IMAGE_SUCCESS:
      return { ...state, loading: false, image: action.image, error: null };
    case GET_IMAGE_FAILURE:
      return { ...state, loading: false, image: null, error: action.error };
    default:
      return state;
  }
}

export default downloadImageReducer;

export function getImage(uri) {
  return {
    type: GET_IMAGE,
    [WAIT_FOR_ACTION]: GET_IMAGE_SUCCESS,
    [ERROR_ACTION]: GET_IMAGE_FAILURE,
    uri
  };
}

export function getImageSuccess(image) {
  return {
    type: GET_IMAGE_SUCCESS,
    image
  };
}

export function getImageFailure(error) {
  return {
    type: GET_IMAGE_FAILURE,
    error
  };
}